import { Navigate, Outlet } from 'react-router';
import { isCatalogEnabled } from '@bill-alps/backend/features/companies/catalog';
import { useCurrentUser } from '@/hooks/use-current-user';
import { PageLoader } from './page-loader';

export function CatalogGate() {
  const { user, isLoading } = useCurrentUser();

  if (isLoading) return <PageLoader />;
  if (!isCatalogEnabled(user?.company)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
